export const AvailableSectors = {
  NONE: { i18n: 'esg.quiz.sensitiveBusiness.sector.none', code: 'NONE' },
  AGRICULTURE_FARMING_AND_FISHING: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.agriculture-farming-and-fishing',
    code: 'AGRICULTURE_FARMING_AND_FISHING',
  },
  CONSTRUCTION_AND_ENGINEERING: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.construction-and-engineering',
    code: 'CONSTRUCTION_AND_ENGINEERING',
  },
  FOOD_AND_BEVERAGE: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.food-and-beverage',
    code: 'FOOD_AND_BEVERAGE',
  },
  FORESTRY_AND_PAPER_PRODUCTS: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.forestry-and-paper-products',
    code: 'FORESTRY_AND_PAPER_PRODUCTS',
  },
  METALS_AND_MINING: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.metals-and-mining',
    code: 'METALS_AND_MINING',
  },
  OIL_AND_GAS: { i18n: 'esg.quiz.sensitiveBusiness.sector.oil-and-gas', code: 'OIL_AND_GAS' },
  PHARMACEUTICALS_AND_BIOTECHNOLOGY: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.pharmaceuticals-and-biotechnology',
    code: 'PHARMACEUTICALS_AND_BIOTECHNOLOGY',
  },
  UTILITIES: {
    i18n: 'esg.quiz.sensitiveBusiness.sector.utilities',
    code: 'UTILITIES',
  },
};
